<div class="box-dialog-wrapper coupons-details-wrapper">
  <header #dialogHeader class="box-dialog-header">
    <box-dialog-header [title]="dialogTitle" alignment="center" (closeDialog)="closeDialog()"></box-dialog-header>
  </header>
  <main #dialogBody bodyScroll (bodyScroll)="onBodyScroll($event)" class="box-dialog-content">
    <div class="coupon-details-dialog-content">
      <div *ngIf="showCountDown" class="coupon-details-dialog-content-countdown">
        <coupon-countdown [coupon]="coupon"></coupon-countdown>
      </div>
      <div
        *ngIf="detailsDescription"
        [innerHTML]="detailsDescription"
        class="coupon-details-dialog-content-description"
      ></div>
      <div *ngIf="redemptionDateText" class="coupon-details-dialog-content-row">
        <div class="coupon-details-dialog-content-row-title">{{ 'last_redemption' | translate }}</div>
        <div class="coupon-details-dialog-content-row-text">{{ redemptionDateText }}</div>
      </div>
      <div *ngIf="expirationDateText" class="coupon-details-dialog-content-row">
        <div class="coupon-details-dialog-content-row-title">{{ 'expiration_date' | translate }}</div>
        <div class="coupon-details-dialog-content-row-text">{{ expirationDateText }}</div>
      </div>
      <div *ngIf="remainingValueText" class="coupon-details-dialog-content-row">
        <div class="coupon-details-dialog-content-row-title">{{ 'you_have_a_balance' | translate }}</div>
        <div class="coupon-details-dialog-content-row-text">{{ remainingValueText }}</div>
      </div>
      <div *ngIf="code" class="coupon-details-dialog-content-row">
        <div class="coupon-details-dialog-content-row-title">{{ 'code_' | translate }}</div>
        <div class="coupon-details-dialog-content-row-text">{{ code }}</div>
      </div>
      <div *ngIf="filteredShops.length" class="coupon-details-dialog-content-shops">
        @for (shop of filteredShops; track shop._id) {
          <div
            [reactComponent]="ShopTileComponent$"
            (click)="onShopCardClick(shop)"
            (keydown.enter)="onShopCardClick(shop)"
            tabindex="-1"
            class="hoverable"
            [props]="{
              shop,
              onRouterClick: this.onRouterClick.bind(this)
            }"
          ></div>
        }
      </div>
    </div>
  </main>
  <footer *ngIf="showCta" #dialogFooter class="box-dialog-footer coupon-details-dialog-button-container">
    <button class="coupon-details-dialog-button" box-button theme="primary" (click)="onCouponAction()">
      {{ buttonText | translate }}
    </button>
  </footer>
</div>
